import { createAsyncAction } from 'typesafe-actions';
import * as types from './actionTypes';
import { MapStatisticOverviewResponse, MapStatisticOverviewQuery } from 'constants/api/v1/types';

export const fetchMapStatisticsAsync = createAsyncAction(
  types.FETCH_MAP_STATISTICS_REQUEST,
  types.FETCH_MAP_STATISTICS_SUCCESS,
  types.FETCH_MAP_STATISTICS_FAILURE
)<{ query: MapStatisticOverviewQuery }, { data: MapStatisticOverviewResponse['data'] }, { error: boolean | null }>();
